import React, { useEffect, useState} from 'react'
import Button from '@mui/material/Button';
import swal from 'sweetalert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {makeStyles} from '@mui/styles';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import InputAdornment from '@mui/material/InputAdornment';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { add_value_to_list, update_value_from_list } from '../../../services/company_admin_service';


const useStyles = makeStyles((theme) => ({
    button: { margin: 8,},
    root: {
      '& > *': {
        margin: 8,
      },
    }
  }));

function Add_infos_modal({add_infos_modal,setadd_infos_modal,infos_type,update_infos,setupdate_infos,data,setData}){

    const classes = useStyles();

    const [errorText,setErrorText] = useState("");

    const [label,setlabel]=useState("");
    const [code,setcode]=useState("");

    const [waiting,setWaiting] = useState(false);

    useEffect(()=>{
      if(update_infos){
            setlabel(update_infos.label);
            setcode(update_infos.code);
        }
    },[]);

    function submit(){
        setErrorText('');
        if(code==="" || label==="") setErrorText('Champs invalides !');
        else{
            swal({
                title: "Etes-vous sûr ?",
                text: "!!!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
            .then(async (willDelete) => {
              if (willDelete) {
                setWaiting(true);
                let formData = new FormData();
                if(update_infos) formData.append('id',update_infos.id);
                formData.append('code',code);
                formData.append('label',label);
                formData.append("type",infos_type);
                if(update_infos){
                    await update_value_from_list(formData).then((response)=>{
                     //  console.log(response.data);
                      let tmp_json = {...data};
                      if(tmp_json.hasOwnProperty(infos_type)) tmp_json[infos_type][update_infos.id] = response.data;
                      setData(tmp_json);
                    }).catch((error)=>{
                     //  console.log(error.response);
                    })
                  swal("Les modifications ont été apportées !", {
                    icon: "success",
                    buttons: true,
                    });
                  
                }else{
                  await add_value_to_list(formData).then((response)=>{
                   //  console.log(response.data);
                    let tmp_json = {...data};
                    if(tmp_json.hasOwnProperty(infos_type)) tmp_json[infos_type].push(response.data);
                    else {
                      tmp_json[infos_type] = [response.data];
                    }
                    setData(tmp_json);
                  }).catch((error)=>{
                   //  console.log(error.response);
                  })
                  swal("L'ajout a été fait !", {
                    icon: "success",
                    buttons: true,
                    });
                }
                setadd_infos_modal(false);
                setupdate_infos(null);
                setWaiting(false);
            }
            })
        }
    }

    return (
      <Dialog fullWidth={true} maxWidth={'md'} open={add_infos_modal} onClose={()=>{setupdate_infos(null);setadd_infos_modal(false)}} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-title">
            {!update_infos?"Ajouter":"Modifier"}
        </DialogTitle>
        <DialogContent>
          <div className="inputs_container">
                <TextField variant='standard' className={classes.margin} label="Code" style={{width:"250px"}} value={code}
                    InputProps={{ startAdornment: ( <InputAdornment position="start"> <BookmarkIcon  /> </InputAdornment> ), }} onChange={(e)=>setcode(e.target.value)} />
                 <TextField variant='standard' className={classes.margin} label="Libellé" style={{width:"250px"}} value={label}
                    InputProps={{ startAdornment: ( <InputAdornment position="start"> <BookmarkIcon  /> </InputAdornment> ), }} onChange={(e)=>setlabel(e.target.value)} />
                    <div className={classes.margin} style={{width:"250px"}}></div>
          </div>
        </DialogContent>
        <DialogActions>
          <div className='dialogBottom'>
            <div>
                {
                    errorText === ""
                    ?<></>
                    :<p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                            {errorText}
                        </p>
                }
            </div>
            <div>
                <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon />} onClick={()=>{setupdate_infos(null);setadd_infos_modal(false)}}>
                    Annuler
                </Button>
                <Button variant="contained" className="submit_but valide_but" startIcon={<AddIcon />} onClick={submit} >
                   {update_infos?"Modifier":'Ajouter'}
                </Button>  
            </div>
               
          </div>
        </DialogActions>

        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={waiting}
        >
            <CircularProgress color="inherit" />
        </Backdrop>

      </Dialog>
    )
}

export default Add_infos_modal
